import styled from 'styled-components';

import { maxWidth } from '@calm-web/design-system';

export const Container = styled.div`
	${maxWidth('desktop')} {
		width: 90%;
		left: 5%;
		position: relative;
		height: inherit;
		display: inline-block;
		margin-bottom: 40px;
	}
	width: 890px;
	height: 440px;
	margin: 0 auto;
`;
